// extracted by mini-css-extract-plugin
export default {"container1":"mainLayout_container1__13ypd","navLogo":"mainLayout_navLogo__3uWOK","appBarTitleBox":"mainLayout_appBarTitleBox__sC6Gb"};